import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useRESTFetcher } from '../../../../api/useRESTFetcher';
import { API_URL } from '../../../../config/endpoints';

export interface SubmitSurveyResponseBody {
	uuid: string;
	responseJson: Record<string, any>;
}

interface Response {
	status: number;
	message?: string;
}

export const useSubmitSurveyResponse = <TError = unknown, TContext = unknown>(
	op: { opcode: string },
	inputProps?: UseMutationOptions<Response, TError, SubmitSurveyResponseBody, TContext> | undefined
) => {
	const { koiFetch } = useRESTFetcher();
	const postSubmitSurveyResponse = async (props: SubmitSurveyResponseBody): Promise<Response> => {
		return koiFetch(`${API_URL}/forms/submitResponse`, {
			method: 'POST',
			body: JSON.stringify(props as SubmitSurveyResponseBody),
		});
	};

	return useMutation<Response, TError, SubmitSurveyResponseBody, TContext>({
		mutationFn: (props: SubmitSurveyResponseBody) => postSubmitSurveyResponse(props),
		...inputProps,
		onError: () => {
			console.error(`OPCODE: ${op.opcode}`);
		},
	});
};
